export function postArchiveInit() {
	document.addEventListener( 'DOMContentLoaded', function() {
		// Don't run this script if not in correct archive page
		if ( ! document.querySelector( '.archive-page' ) ) {
			return;
		}

		const archiveDropDowns = document.querySelectorAll( '.archive-post-dropdown' );

		const mapParams = ( element ) => {
			if ( element.checked ) {
				return element.value;
			}
		};

		const fetchData = async () => {
			document.querySelector( '.archive-post-items-overlay' ).classList.add( 'active' );

			const categories = [ ...document.querySelectorAll( '[data-term="post-category"]' ) ].filter( ( item ) => item.checked && item.value !== '' ).map( mapParams );
			const years = [ ...document.querySelectorAll( '[data-term="post-year"]' ) ].filter( ( item ) => item.checked && item.value !== '' ).map( mapParams );

			const paramCategory = categories.length > 0 ? `category=${ categories.join( ',' ) }` : '';
			const paramYear = years.length > 0 ? `year=${ years.join( ',' ) }` : '';

			const params = `${ [ paramCategory, paramYear ].filter( Boolean ).join( '&' ) }`;

			const fetchUrl = `${ window.location.origin }/wp-json/wp-exove/v2/post/${ params !== '' ? '?' + params : '' }`;

			await fetch( fetchUrl )
				.then( ( res ) => {
					return res.json();
				} )
				.then( ( data ) => {
					document.querySelector( '#archive-post-list' ).innerHTML = data.html;
				} )
				.finally( () => {
					document.querySelector( '.archive-post-items-overlay' ).classList.remove( 'active' );
				} );

			const pathCleaned = window.location.pathname.replace( /page(.*)/, '' );
			const newUrl = window.location.protocol + '//' + window.location.host + pathCleaned + ( params !== '' ? '?' + params : '' );
			window.history.pushState( { path: newUrl }, document.title, newUrl );
		};

		const onInputChange = ( el ) => {
			if ( el.target.id === `all-${ el.target.dataset.term }` ) {
				document.querySelectorAll( `[data-term="${ el.target.dataset.term }"]` ).forEach( ( item ) => {
					if ( item.id !== `all-${ el.target.dataset.term }` ) {
						item.checked = false;
					}
				} );
			} else if ( [ ...document.querySelectorAll( `[data-term="${ el.target.dataset.term }"]` ) ].filter( ( item ) => item.id !== `#all-${ el.target.dataset.term }` ).every( ( item ) => ! item.checked ) ) {
				document.querySelector( `#all-${ el.target.dataset.term }` ).checked = true;
			} else {
				document.querySelector( `#all-${ el.target.dataset.term }` ).checked = false;
			}

			fetchData();
		};

		document.getElementById( 'post-category' ).addEventListener( 'change', onInputChange );
		document.getElementById( 'post-year' ).addEventListener( 'change', onInputChange );

		const closeDropdowns = () => {
			archiveDropDowns.forEach( ( dropdown ) => {
				dropdown.classList.remove( 'open' );
			} );
		};

		archiveDropDowns.forEach( ( dropdown ) => {
			dropdown.querySelector( 'button' ).onclick = function( e ) {
				if ( ! dropdown.classList.contains( 'open' ) ) {
					closeDropdowns();
					dropdown.classList.add( 'open' );
				} else {
					dropdown.classList.remove( 'open' );
				}
				e.stopPropagation();
			};
			dropdown.onclick = function( e ) {
				dropdown.classList.add( 'open' );
				e.stopPropagation();
			};
		} );

		document.addEventListener( 'keydown', ( e ) => {
			if ( e.code === 'Escape' ) {
				closeDropdowns();
			}
		} );

		document.onclick = function() {
			closeDropdowns();
		};
	} );
}
